module.exports = __webpack_public_path__ + "static/media/img_top_main1@2x.831cd714.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_top_main1@2x.webp
// module id = 773
// module chunks = 0